import { render, staticRenderFns } from "./expertlist.vue?vue&type=template&id=6c8b0791&scoped=true"
import script from "./expertlist.vue?vue&type=script&lang=js"
export * from "./expertlist.vue?vue&type=script&lang=js"
import style0 from "./expertlist.vue?vue&type=style&index=0&id=6c8b0791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8b0791",
  null
  
)

export default component.exports